export enum PARENT_TYPE {
    COUNTRY = 'COUNTRY',
    STATE = 'STATE'
}
